import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    getters: {
        indexMenu: state => state.indexMenu,
        adminMenu: state => state.adminMenu,
        schoolMenu: state => state.schoolMenu,
        teacherMenu: state => state.teacherMenu,
        judgesMenu: state => state.judgesMenu,
        studentMenu: state => state.studentMenu,
        studentExamData: state => state.studentExamData,
    },
    state: {
        undone: 0,
        indexMenu: [],
        adminMenu: [],
        schoolMenu: [],
        teacherMenu: [],
        judgesMenu: [],
        studentMenu: [],
        studentExamData:{},
    },
    mutations: {
        SET_INDEX_ROUTES: (state, routes) => {
            state.indexMenu = routes
        },
        SET_ADMIN_ROUTES: (state, routes) => {
            state.adminMenu = routes
        },
        SET_SCHOOL_ROUTES: (state, routes) => {
            state.schoolMenu = routes
        },
        SET_TEACHER_ROUTES: (state, routes) => {
            state.teacherMenu = routes
        },
        SET_JUDGES_ROUTES: (state, routes) => {
            state.judgesMenu = routes
        },
        SET_STUDENT_ROUTES: (state, routes) => {
            state.studentMenu = routes
        },
        setStudentExamData: (state, payload) => {
            state.studentExamData = payload
        }
    },
    actions: {
        generateIndexRoutes({ commit }, indexRoutes) {
            commit('SET_INDEX_ROUTES', indexRoutes)
        },
        generateAdminRoutes({ commit }, adminRoutes) {
            commit('SET_ADMIN_ROUTES', adminRoutes)
        },
        generateSchoolRoutes({ commit }, schoolRoutes) {
            commit('SET_SCHOOL_ROUTES', schoolRoutes)
        },
        generateTeacherRoutes({ commit }, teacherRoutes) {
            commit('SET_TEACHER_ROUTES', teacherRoutes)
        },
        generateJudgesRoutes({ commit }, judgesRoutes) {
            commit('SET_JUDGES_ROUTES', judgesRoutes)
        },
        generateStudentRoutes({ commit }, studentRoutes) {
            commit('SET_STUDENT_ROUTES', studentRoutes)
        },
    },
    modules: {
    }
})
